import request from '@/utils/request'

// 查询业务在线申请管理详细
export function getYwzxsqOperation(parentRecid) {
  return request({
    url: '/web/system/ywzxsqoperation/' + parentRecid,
    method: 'get'
  })
}